var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7848 5.05658C12.0173 4.82402 12.0173 4.44798 11.7848 4.2179C11.5522 3.98783 11.1762 3.98535 10.9461 4.2179L8.00208 7.16191L5.0556 4.21543C4.82305 3.98288 4.44701 3.98288 4.21693 4.21543C3.98685 4.44798 3.98437 4.82402 4.21693 5.0541L7.16094 7.99811L4.21445 10.9446C3.9819 11.1771 3.9819 11.5532 4.21445 11.7833C4.44701 12.0133 4.82305 12.0158 5.05313 11.7833L7.99714 8.83926L10.9436 11.7857C11.1762 12.0183 11.5522 12.0183 11.7823 11.7857C12.0124 11.5532 12.0148 11.1771 11.7823 10.9471L8.83828 8.00306L11.7848 5.05658Z",
    fill: "#C53D3D"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.c2718cb599ec9d0d279db4615a09f634.svg";
export { ForwardRef as ReactComponent };